import { useEffect } from 'react'

const useOnUnountEffect = fn => {
  useEffect(() => {
    return fn
  }, []) // eslint-disable-line
}

export default useOnUnountEffect
